import classNames from 'classnames'
import React from 'react'
import { APPLE_STORE_URL, PLAY_STORE_URL } from '../../parameters'
import { TAG_BLOCK_AUTOPROMO } from '../analytics/analytics.tagids.constants'
import { MODAL_IDS } from '../../store/ui/ui.constants'
import analyticsConstants from '../analytics/analytics.constants'
import Modal from '../genericComponents/Modal'
import TagActionLink from '../genericComponents/TagActionLink'
import cross from '../genericComponents/assets/cross.svg'
import france from '../genericComponents/assets/france.svg'
import mappyLogoOutline from '../genericComponents/assets/mappy-logo-outline.svg'
import roadRadar from '../genericComponents/assets/road-radar.svg'
import SVGIcon from '../svg/SVGIcon'
import useModal from '../ui/useModal'
import useEventCallback from '../utils/useEventCallback'
import s from './AutoPromoPopinGE.less'
import qrcode from './assets/qrcode-stores.png'

const StoreButton = ({ url, className, appstore }) => {
  return (
    <TagActionLink
      className={classNames(s.storeButton, className)}
      href={url}
      nofollow={true}
      targetBlank={true}
      type={TAG_BLOCK_AUTOPROMO}
      tagInfo={{ appstore, area: analyticsConstants.autopromo.area.popin }}
    />
  )
}

const AutoPromoPopinGE = () => {
  const { hideModal } = useModal(MODAL_IDS.AUTO_PROMO_POPIN)
  const onPopinClose = useEventCallback(hideModal)

  return (
    <Modal modalId={MODAL_IDS.AUTO_PROMO_POPIN}>
      <div className={s.closeButton} onClick={onPopinClose}>
        <SVGIcon url={cross} />
      </div>
      <div className={s.root}>
        <div className={s.leftPart}>
          <div className={s.qrcodeWrapper}>
            <img src={qrcode} />
          </div>
          <ol className={s.instructions}>
            <li>
              <b>Scannez le QR Code</b> avec l&apos;appareil photo de votre téléphone
            </li>
            <li>
              <b>Cliquez</b> sur le lien
            </li>
            <li>
              <b>Téléchargez</b> l&apos;app
            </li>
          </ol>
          <div>
            <StoreButton
              url={PLAY_STORE_URL}
              className={s.androidButton}
              appstore={analyticsConstants.autopromo.stores.android}
            />
            <StoreButton
              url={APPLE_STORE_URL}
              className={s.iosButton}
              appstore={analyticsConstants.autopromo.stores.ios}
            />
          </div>
        </div>
        <div className={s.rightPart}>
          <div className={s.title}>Pour une expérience complète, téléchargez l&apos;application Mappy</div>
          <ul className={s.advantagesList}>
            <li className={s.advantagesItem}>
              <div className={s.advantagesIcon}>
                <SVGIcon url={mappyLogoOutline} />
              </div>
              <div>Un GPS efficace et gratuit</div>
            </li>
            <li className={s.advantagesItem}>
              <div className={s.advantagesIcon}>
                <SVGIcon url={roadRadar} />
              </div>
              <div>Trafic en temps réel, zones de contrôle et alertes dépassement de vitesse</div>
            </li>
            <li className={s.advantagesItem}>
              <div className={s.advantagesIcon}>
                <SVGIcon url={france} />
              </div>
              <div>100% made in France qui respecte la vie privée</div>
            </li>
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default AutoPromoPopinGE
